// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".compose-email-drawer {\n  border-radius: 6px 6px 0 0;\n}\n", ""]);
// Exports
module.exports = exports;
